/**
 * Composable that provides an email hashing helper backed by the `/v1/utils/encrypt/` endpoint.
 * Used before sending email addresses to analytics to avoid PII leaks.
 */
export const useEncryptEmail = async () => {
	const getEncryptEmail = async (paylod: any) => {
		const { $repository } = useNuxtApp()

		const response = await $repository.v1.utils.postEncryptEmail(paylod)
		if (!response.success) return ''
		return response.result.hash
	}
	return {
		getEncryptEmail,
	}
}
